module.exports = __webpack_public_path__ + "img/noun_validation.88dcc672.svg";